module.exports = __webpack_public_path__ + "static/media/sms5.a6e8dccd.png";